import Header from "src/components/layout/Header";
import RefundPolicy from "./RefundPolicy";
import { useLocation } from "react-router-dom";
import { usePartnerNavigate } from "src/api/hooks/usePartnerNavigate";

// 서비스 타입 환불 정책 컴포넌트
// 결제 및 취소 안내 정보를 표시하는 모달 컴포넌트
const ServiceTypeRefundPolicy = () => {
  // 네비게이션 및 위치 정보
  const navigate = usePartnerNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // URL 파라미터에서 환불 정보 가져오기
  const getRefundInfo = () => {
    try {
      const data = searchParams.get("data");
      if (!data) return {};
      return JSON.parse(decodeURIComponent(data));
    } catch (error) {
      console.error("Failed to parse refund info:", error);
      return {};
    }
  };

  const refundInfo = getRefundInfo();

  // 모달 닫기 핸들러
  const onClose = () => {
    navigate(-1);
  };

  return (
    <>
      {/* 헤더 컴포넌트 */}
      <Header
        headerType="BACK"
        title="결제 및 취소 안내"
        onClickBackButton={() => {
          onClose()!;
        }}
      />

      {/* 환불 정책 컴포넌트 */}
      <RefundPolicy refundInfo={refundInfo} />
    </>
  );
};

export default ServiceTypeRefundPolicy;
